"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreadcrumbSchema = void 0;
const getBreadcrumbSchema = (items, domain) => {
    const breadcrumbItems = items.map((item, index) => {
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@id': `${domain}${item.url}`,
                name: item.name,
            },
        };
    });
    return {
        itemListElement: [...breadcrumbItems],
    };
};
exports.getBreadcrumbSchema = getBreadcrumbSchema;
